import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styles from './accordion.module.scss';
import IAccordion from '../../../models/accordion/IAccordion';
import { getHeapAttributes } from '../../../utils/heap/heap.helper';

export default function Accordion({ id, heading, content, heapIdentifier, isOpened }: IAccordion) {
  const [isOpen, setOpen] = useState(isOpened);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const clickHandler = useCallback(() => {
    setOpen(!isOpen);
  }, [isOpen]);

  const heapAttributes = useMemo(
    () => heapIdentifier && getHeapAttributes(heapIdentifier, { accordionItem: id }),
    [id, heapIdentifier],
  );

  return (
    <div className={`${styles[`accordion-card`]}`} id={id}>
      <div className={`${styles[`accordion-header`]} ${isOpen && styles[`open`]}`}>
        <h3 tabIndex={-1}>
          <button
            type='button'
            role='button'
            tabIndex={0}
            aria-expanded={isOpen}
            className={`${styles[`accordion-trigger`]} ${isOpen && styles[`open`]}`}
            aria-controls={id}
            id={`accordion-${id}`}
            onClick={() => clickHandler()}
            data-accordion-component='AccordionItemButton'
            {...heapAttributes}
          >
            <span className={`${styles[`accordion-title`]}`}>
              {heading}
              <span className={`${styles[`accordion-icon`]}`}></span>
            </span>
          </button>
        </h3>
      </div>
      <div
        id={`accordion-item-${id}`}
        role='region'
        aria-labelledby={`accordion-${id}`}
        data-accordion-component='AccordionItemPanel'
        className={`${styles[`accordion-collapse`]} ${isOpen && styles[`open`]}`}
      >
        <div className={`${styles[`accordion-content`]}`}>
          {content}
        </div>
      </div>
    </div>
  );
}
